import { effect, inject, Injectable, signal } from '@angular/core';
import { OpkraevningsListe } from '@features/opkraevningslister/opkraevningsliste.model';
import { OpkraevningsListerSearchParams } from '@features/opkraevningslister/opkraevningslister-search/opkraevningslister-search-params.model';
import { OpkraevningsListerDatasource } from './opkraevningslister.datasource';
import { OpkraevningsListeSummary } from './opkraevningsliste-summary.model';
import { SimpleApi } from '@core/api/simple.api';
import { downloadFromBlob } from '@core/api/api-utils';

@Injectable({
  providedIn: 'root',
})
export class OpkraevningsListerService {
  datasource = inject(OpkraevningsListerDatasource);
  simpleApi = inject(SimpleApi);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  selectedOpkraevningsListe = signal<OpkraevningsListe | undefined>(undefined);
  summary = signal<OpkraevningsListeSummary | undefined>(undefined);
  activeTab = signal('search');

  searchOpkraevningsListe(searchParams: OpkraevningsListerSearchParams) {
    this.selectedOpkraevningsListe.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  async selectOpkraevningsListeResultRow(opkraevningsliste: OpkraevningsListe) {
    await this.selectOpkraevningsListe(opkraevningsliste);

    if (opkraevningsliste) {
      this.activeTab.set('detail');
    }
  }

  async selectOpkraevningsListe(opkraevningsliste: OpkraevningsListe) {
    const ol = await this.datasource.getById(opkraevningsliste.id!);
    this.selectedOpkraevningsListe.set(ol);
    await this.loadSummary();
  }

  async loadSummary() {
    const id = this.selectedOpkraevningsListe()?.id;
    if (id) {
      const s = await this.datasource.getSummary(id);
      this.summary.set(s);
    }
  }

  async exportData(opkraevningsListeId: number) {
    const blob = await this.simpleApi.getBlob(
      `/api/admin/opkraevningslister/excel`,
      {
        opkraevningsListeId: opkraevningsListeId,
      }
    );
    downloadFromBlob(blob, 'Opkrævningsliste.xlsx');
  }
}
